import { BoxV2 as Box, Flex, RoleGuard } from 'portal-commons';
import React, { FunctionComponent } from 'react';
import { Grid } from '@material-ui/core';
import { faMessageDots, faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CampaignSampleMessage from '../CampaignSampleMessage';
import SectionHeader from '../SectionHeader';
import { CampaignDetail } from '@/apis/core';

interface SampleMessagesSectionProp {
  readonly?: boolean;
  campaign: CampaignDetail;
  onEdit?: () => void;
}

const SampleMessagesSection: FunctionComponent<SampleMessagesSectionProp> = ({
  readonly,
  campaign,
  onEdit,
}) => {
  return (
    <Grid item xs={12}>
      <SectionHeader
        data-testid="campaignDetailSampleMessage"
        icon={faMessageDots}
        title="Sample Messages"
      >
        <RoleGuard feature="campaignDetail.editSampleMessages">
          <Flex
            data-testid="campaignDetailSampleMessageEditButton"
            className={readonly ? 'edit-btn disabled' : 'edit-btn'}
            onClick={onEdit}
          >
            <Box sx={{ mr: 'xs' }}>
              <FontAwesomeIcon icon={faPen} color="#0091B3" />
            </Box>
            <span>Edit</span>
          </Flex>
        </RoleGuard>
      </SectionHeader>
      {campaign.sample1 && (
        <CampaignSampleMessage index={1} message={campaign.sample1} />
      )}
      {campaign.sample2 && (
        <CampaignSampleMessage index={2} message={campaign.sample2} />
      )}
      {campaign.sample3 && (
        <CampaignSampleMessage index={3} message={campaign.sample3} />
      )}
      {campaign.sample4 && (
        <CampaignSampleMessage index={4} message={campaign.sample4} />
      )}
      {campaign.sample5 && (
        <CampaignSampleMessage index={5} message={campaign.sample5} />
      )}
    </Grid>
  );
};

export default SampleMessagesSection;
